(function ($) {
  const $body = $('body');
  const $searchButton = $('.js-navbar-search');
  const $searchModal = $('.block-views-exposed-filter-blocksearch-page-1');
  const $buttonSearch = $('.block-views-exposed-filter-blocksearch-page-1 .js-form-item');
  const $searchInput = $('.block-views-exposed-filter-blocksearch-page-1 input');
  const $form = $('.block-views-exposed-filter-blocksearch-page-1 form');

  const flexClass = 'u-flex';

  const searchModalClose = document.createElement('div');
  searchModalClose.className = "search-close-button";
  $searchModal.append(searchModalClose);
  const $searchModalClose = $('.search-close-button');


  $searchButton.on('click', (e) => {
    if (!$searchModal.hasClass(flexClass)) {
      $searchModal.addClass(flexClass);
      $body.addClass('is-open search-open');
      $searchInput.focus();
    } else {
      $searchModal.removeClass(flexClass);
      $body.removeClass('is-open search-open');
    }
    e.stopPropagation();
  });

  $searchModalClose.on('click', (e) => {
    $searchButton.trigger('click');
  });

  $searchInput.attr("placeholder", "Typ hier je zoekopdracht");

  $buttonSearch.click(function (e) {
    if (e.target.classList.contains('form-item')){
       $form.submit();
    }
    e.stopPropagation();
  });

  $searchModal.click(function (e) {
    e.stopPropagation();
  });

  $(document).click(function(e) {
    $searchModal.removeClass(flexClass);
  });
  
})(jQuery);